var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"level2"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,staticClass:"subhead",on:{"click":function($event){return _vm.select(item, index)}}},[_vm._v("\n    "+_vm._s(item.name)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }